var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _polygon, _polygon2, _path2, _g, _g2, _rect, _text;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "2088.835px",
    height: "1662.303px",
    viewBox: "0 0 2088.835 1662.303",
    enableBackground: "new 0 0 2088.835 1662.303",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    fill: "#2B363F",
    d: "M181.444,976.769l59.083-99.984c9.739-16.515,16.191-34.747,18.682-53.753 c4.284-32.456,5.106-82.996-19.579-125.739c-38.957-67.329-9.291-261.617,46.131-355.822c1.495-2.814,3.039-5.38,4.658-7.622 c-0.025,0.025-0.025,0.05-0.025,0.075c-1.818,3.736-39.779,82.946-15.767,163.8c0.373,1.17,2.117,0.946,2.142-0.274 c1.595-68.051,20.5-111.067,20.5-111.067v0.099c21.372-53.928,72.36-116.324,187.439-164.996c0.125-0.075,0.249-0.125,0.374-0.174 c0.05-0.025,0.075-0.05,0.125-0.05c0,0,197.634-94.562,448.98-6.9c233.75,81.525,272.971,332.097,273.489,336.417 c27.312,116.284-0.334,200.639-1.245,204.141c0.498-5.455,25.216-223.22-107.199-363.556 c-121.779-129.078-287.796-132.091-311.26-131.319c-2.54,0.075-5.006,0.1-7.547,0.025c-31.933-0.748-249.711,1.544-356.345,199.769 C308.853,674.052,500.352,953.18,500.352,953.18s73.032,108.727,167.163,228.812c94.13,120.086-21.098,214.216-21.098,214.216 s-75.873,71.588-130.821,101.803c-2.043,1.12-4.086-1.47-2.541-3.214c27.175-30.637,112.887-136.849,61.948-205.697 c0,0-24.336-40.576-61.674-16.215c-37.313,24.336-126.561,42.195-126.561,42.195s-30.713,5.455-56.892-14.547 c-16.266-12.454-25.706-31.883-26.752-52.357l-2.839-56.12c-0.225-4.434-1.744-8.718-4.384-12.329l-18.382-25.059 c-2.716-3.711-3.413-8.544-1.868-12.878l5.405-15.045c2.117-5.953,0.797-12.579-3.462-17.237l-21.347-23.414 c-3.736-4.085-5.804-9.415-5.804-14.945v-23.314c0-6.75-3.388-13.053-9.017-16.788l-56.02-37.064 C179.701,990.219,177.982,982.647,181.444,976.769z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_239_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_395_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2264.4922,
    y1: 720.4556,
    x2: 1823.606,
    y2: 409.0952,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_396_",
    fill: "url(#XMLID_2_)",
    cx: 909.81,
    cy: 416.656,
    r: 46.912
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2355.1328,
    y1: 592.1045,
    x2: 1914.248,
    y2: 280.7451,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_394_",
    fill: "url(#XMLID_4_)",
    cx: 791.835,
    cy: 307.608,
    r: 29.777
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_391_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2315.3984,
    y1: 648.3633,
    x2: 1874.5167,
    y2: 337.0061,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_392_",
    fill: "url(#XMLID_5_)",
    cx: 791.835,
    cy: 391.928,
    r: 34.817
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_327_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2314.6846,
    y1: 649.3784,
    x2: 1873.7998,
    y2: 338.0191,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_390_",
    fill: "url(#XMLID_6_)",
    cx: 892.675,
    cy: 322.232,
    r: 29.777
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 2381.6445,
    y1: 554.5532,
    x2: 1940.767,
    y2: 243.199,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_326_",
    fill: "url(#XMLID_7_)",
    cx: 691.443,
    cy: 322.232,
    r: 29.777
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 2395.001,
    y1: 535.6621,
    x2: 1954.1073,
    y2: 224.2965,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_324_",
    fill: "url(#XMLID_8_)",
    cx: 599.241,
    cy: 359.023,
    r: 25.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_320_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 2384.6455,
    y1: 550.314,
    x2: 1943.7626,
    y2: 238.9559,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_321_",
    fill: "url(#XMLID_9_)",
    cx: 531.798,
    cy: 428.618,
    r: 32.984
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_316_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 2330.0605,
    y1: 627.6064,
    x2: 1889.1776,
    y2: 316.2484,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_318_",
    fill: "url(#XMLID_10_)",
    cx: 594.71,
    cy: 500.029,
    r: 32.984
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_313_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 2290.1123,
    y1: 684.1777,
    x2: 1849.2251,
    y2: 372.8167,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_315_",
    fill: "url(#XMLID_11_)",
    cx: 697.877,
    cy: 511.954,
    r: 26.777
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_279_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 2226.7705,
    y1: 773.8687,
    x2: 1785.8857,
    y2: 462.5093,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_280_",
    fill: "url(#XMLID_12_)",
    cx: 888.222,
    cy: 511.954,
    r: 24.286
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_277_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 2341.3057,
    y1: 611.6929,
    x2: 1900.4147,
    y2: 300.3291,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_278_",
    fill: "url(#XMLID_13_)",
    cx: 678.988,
    cy: 416.656,
    r: 45.666
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_275_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 2270.5127,
    y1: 711.9277,
    x2: 1829.6263,
    y2: 400.5673,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_276_",
    fill: "url(#XMLID_14_)",
    cx: 633.322,
    cy: 599.135,
    r: 45.666
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_273_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 2343.4014,
    y1: 608.7188,
    x2: 1902.5104,
    y2: 297.355,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_274_",
    fill: "url(#XMLID_15_)",
    cx: 473.076,
    cy: 557.62,
    r: 45.667
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_271_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 2236.4268,
    y1: 760.1958,
    x2: 1795.5414,
    y2: 448.8361,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_272_",
    fill: "url(#XMLID_16_)",
    cx: 567.727,
    cy: 717.801,
    r: 37.118
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_269_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 2291.4746,
    y1: 682.2471,
    x2: 1850.5842,
    y2: 370.8838,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_270_",
    fill: "url(#XMLID_17_)",
    cx: 528.135,
    cy: 628.936,
    r: 16.44
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_267_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 2286.5635,
    y1: 689.2007,
    x2: 1845.6771,
    y2: 377.8403,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_268_",
    fill: "url(#XMLID_18_)",
    cx: 445.624,
    cy: 697.628,
    r: 30.617
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_265_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 2217.2959,
    y1: 787.2842,
    x2: 1776.4198,
    y2: 475.9309,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_266_",
    fill: "url(#XMLID_19_)",
    cx: 509.608,
    cy: 799.443,
    r: 22.833
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 2236.75,
    y1: 759.7368,
    x2: 1795.8636,
    y2: 448.3764,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_264_",
    fill: "url(#XMLID_20_)",
    cx: 793.568,
    cy: 557.62,
    r: 45.666
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 2164.4502,
    y1: 862.1128,
    x2: 1723.5642,
    y2: 550.7526,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_262_",
    fill: "url(#XMLID_21_)",
    cx: 950.468,
    cy: 600.25,
    r: 52.204
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 2130.9385,
    y1: 909.561,
    x2: 1690.0542,
    y2: 598.202,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_260_",
    fill: "url(#XMLID_22_)",
    cx: 1112.726,
    cy: 556.777,
    r: 44.109
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_257_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 2198.2549,
    y1: 814.2378,
    x2: 1757.3724,
    y2: 502.8801,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_258_",
    fill: "url(#XMLID_23_)",
    cx: 991.46,
    cy: 499.553,
    r: 34.739
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_255_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 2211.1875,
    y1: 795.9253,
    x2: 1770.3051,
    y2: 484.5676,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_256_",
    fill: "url(#XMLID_24_)",
    cx: 1052.743,
    cy: 428.828,
    r: 34.739
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_253_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 2056.7715,
    y1: 1014.5942,
    x2: 1615.8826,
    y2: 703.232,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_254_",
    fill: "url(#XMLID_25_)",
    cx: 1137.166,
    cy: 696.928,
    r: 32.237
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_251_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 2176.8613,
    y1: 844.5278,
    x2: 1735.9836,
    y2: 533.1735,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_252_",
    fill: "url(#XMLID_26_)",
    cx: 839.235,
    cy: 652.456,
    r: 36.325
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_249_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 2119.0635,
    y1: 926.3696,
    x2: 1678.1855,
    y2: 615.0151,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_250_",
    fill: "url(#XMLID_27_)",
    cx: 906.748,
    cy: 727.436,
    r: 27.482
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_247_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 2265.3838,
    y1: 719.1831,
    x2: 1824.5024,
    y2: 407.8262,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_248_",
    fill: "url(#XMLID_28_)",
    cx: 987.325,
    cy: 360.011,
    r: 26.362
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_245_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 2278.4678,
    y1: 700.6563,
    x2: 1837.5865,
    y2: 389.2994,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_246_",
    fill: "url(#XMLID_29_)",
    cx: 793.569,
    cy: 469.078,
    r: 19.304
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_243_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 2253.8857,
    y1: 735.4731,
    x2: 1813.0012,
    y2: 424.114,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_244_",
    fill: "url(#XMLID_30_)",
    points: "924.828,570.859 932.986,565.14 896.015,512.41 900.612,446.84  907.785,428.393 1032.56,431.726 1032.826,421.765 901.04,418.248 890.777,444.636 886.159,510.502 795.105,551.465  708.252,439.162 700.371,445.258 792.031,563.774 889.207,520.056  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_241_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 2311.4766,
    y1: 653.9214,
    x2: 1870.594,
    y2: 342.5636,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_242_",
    fill: "url(#XMLID_31_)",
    points: "569.034,718.148 640.988,600.291 480.008,554.416 536.332,430.681  527.264,426.553 466.143,560.825 625.658,606.282 560.531,712.957  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 2069.1396,
    y1: 997.0718,
    x2: 1628.2537,
    y2: 685.7116,
    gradientTransform: "matrix(-1 0 0 1 2744.1221 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8172,
    style: {
      stopColor: "#EA2424"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    fill: "url(#XMLID_32_)",
    d: "M1012.68,679.298c4.4,0,8.633,0.7,12.612,1.972l14.782-29.71 c-4.51-3.826-7.38-9.526-7.38-15.903c0-11.519,9.337-20.856,20.856-20.856c11.518,0,20.855,9.337,20.855,20.856 c0,11.518-9.337,20.855-20.855,20.855c-1.567,0-3.088-0.187-4.556-0.515l-14.66,29.464c11.827,7.287,19.738,20.316,19.738,35.226 c0,8.066-2.344,15.568-6.334,21.933l34.21,30.758c3.734-2.662,8.291-4.243,13.225-4.243c12.61,0,22.834,10.223,22.834,22.833 s-10.224,22.833-22.834,22.833c-12.609,0-22.832-10.223-22.832-22.833c0-4.067,1.075-7.878,2.939-11.187l-33.807-30.396 c-7.451,7.226-17.594,11.691-28.793,11.691c-22.859,0-41.391-18.531-41.391-41.391S989.82,679.298,1012.68,679.298z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B363F",
    d: "M845.187,1285.797v-203.202h-33.315v-33.898h90.204c24.807,0,43.412,1.494,55.817,4.48 c12.402,2.989,23.346,10.554,32.828,22.697c9.479,12.146,14.222,26.398,14.222,42.764c0,12.6-2.825,23.963-8.475,34.094 c-5.649,10.131-13.93,17.797-24.84,22.99c15.065,5.196,26.657,13.802,34.776,25.813c8.115,12.016,12.176,25.751,12.176,41.206 c0,13.379-3.02,25.521-9.059,36.432c-6.04,10.91-14.061,19.354-24.061,25.327c-10.003,5.976-20.944,10.003-32.828,12.079 c-11.885,2.079-28.088,3.117-48.609,3.117h-92.152v-33.899H845.187z M886.1,1161.5h25.522c19.482,0,33.086-3.409,40.815-10.229 c7.726-6.818,11.592-16.852,11.592-30.1c0-25.717-17.47-38.576-52.408-38.576H886.1V1161.5z M886.1,1285.797h15.391 c20.131,0,34.874-1.005,44.225-3.02c9.352-2.013,16.98-6.752,22.892-14.223c5.908-7.467,8.864-17.047,8.864-28.736 c0-10.648-2.825-19.58-8.475-26.788c-5.65-7.209-12.926-12.013-21.82-14.417c-8.898-2.402-21.464-3.604-37.699-3.604H886.1 V1285.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B363F",
    d: "M1077.807,1285.797v-203.202h-37.211v-33.898h110.076c22.989,0,41.236,1.786,54.746,5.357 c13.507,3.573,24.676,11.104,33.51,22.6c8.831,11.494,13.248,25.811,13.248,42.952c0,35.845-18.621,58.378-55.86,67.599 l47.872,98.593h33.12v33.899h-58.697l-61.705-126.636h-38.186v92.736h34.679v33.899h-112.803v-33.899H1077.807z M1118.72,1159.162 h31.951c15.455,0,26.852-1.005,34.192-3.02c7.336-2.013,13.345-6.104,18.021-12.274c4.676-6.167,7.014-14.447,7.014-24.84 c0-8.831-2.372-16.298-7.111-22.405c-4.743-6.103-10.588-9.966-17.534-11.592c-6.95-1.622-17.568-2.436-31.854-2.436h-34.679 V1159.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B363F",
    d: "M1465.613,1224.427h-97.631l-20.733,61.37h32.925v33.899H1273.41v-33.899h32.792l73.99-206.514h-32.749 v-30.587h138.52v30.587h-33.875l75.838,206.514h30.316v33.899h-106.179v-33.899h33.705L1465.613,1224.427z M1455.397,1192.671 l-36.064-113.388h-3.702l-37.543,113.388H1455.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B363F",
    d: "M1597.013,1285.797v-203.202h-29.224v-33.898h99.36v33.898h-29.224v203.202h29.224v33.899h-99.36v-33.899 H1597.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B363F",
    d: "M1720.727,1285.797v-203.202h-38.77v-33.898h92.508l118.877,210.653v-176.755h-38.381v-33.898h111.244 v33.898h-39.939v239.829h-41.994l-130.035-231.305v194.678h38.77v33.899h-111.049v-33.899H1720.727z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M970.174,956.548v13.442c-12.342,11.562-22.828,20.88-31.465,27.957 c-8.639,7.081-17.242,13.443-25.814,19.093c-8.572,5.65-15.683,9.674-21.333,12.079c-5.649,2.401-10.49,3.604-14.515,3.604 c-9.613,0-17.47-3.574-23.573-10.715c-6.106-7.143-9.157-16.365-9.157-27.666c0-12.986,2.631-25.844,7.891-38.574 c5.261-12.729,12.762-25.879,22.502-39.452c9.742-13.571,21.948-28.801,36.627-45.687c10.91-12.469,16.365-19.482,16.365-21.041 c0-0.907-0.325-1.687-0.974-2.338c-0.651-0.648-1.364-0.975-2.144-0.975c-2.469,0-10.066,5.455-22.794,16.365 c-12.73,10.91-29.063,26.953-48.998,48.122c-19.939,21.172-41.468,46.368-64.584,75.592c-1.3,1.559-5.425,6.853-12.372,15.878 c-6.95,9.029-11.854,14.904-14.709,17.632c-2.858,2.728-5.327,4.091-7.403,4.091c-3.638,0-6.789-3.671-9.449-11.007 c-2.664-7.337-3.994-15.163-3.994-23.477c0-5.065,1.656-10.521,4.968-16.365c3.312-5.845,10.521-16.331,21.625-31.464 c11.105-15.129,20.292-27.891,27.568-38.283c7.272-10.39,15.26-22.989,23.963-37.796c6.104-10.259,10.618-18.441,13.54-24.548 c2.923-6.104,4.384-11.495,4.384-16.17c0-4.024-1.169-6.04-3.507-6.04c-4.938,0-14.223,6.594-27.859,19.774 c-13.638,13.185-30.49,32.764-50.558,58.74c-20.066,25.979-41.01,56.045-62.831,90.203 c-7.145,11.689-12.21,19.549-15.196,23.574c-2.989,4.027-6.301,6.039-9.936,6.039c-4.548,0-8.801-4.837-12.761-14.515 c-3.964-9.674-5.942-17.501-5.942-23.476c0-1.949,0.779-4.092,2.338-6.43c17.145-22.858,31.236-42.277,42.277-58.252 c11.038-15.977,20.846-31.139,29.418-45.492c8.572-14.35,14.807-26.17,18.703-35.458c3.896-9.284,5.845-16.59,5.845-21.917 c0-5.583-2.533-8.377-7.598-8.377c-4.158,0-11.236,2.664-21.236,7.988c-10.003,5.327-22.633,12.6-37.894,21.82 c-15.263,9.224-27.503,16.268-36.724,21.138c-9.224,4.871-16.104,7.307-20.651,7.307c-4.286,0-6.429-2.402-6.429-7.209 c0-2.728,0.91-8.992,2.728-18.801c1.82-9.805,3.702-16.721,5.65-20.749c2.728-5.193,9.708-12.079,20.944-20.651 c11.232-8.572,17.437-12.858,18.605-12.858c1.038,0,1.559,0.457,1.559,1.364c0,0.521-0.521,1.3-1.559,2.338 c-5.327,4.286-9.288,7.793-11.884,10.521c-2.6,2.728-4.222,5.717-4.871,8.962c23.769-14.286,45.035-25.163,63.805-32.633 c18.767-7.467,31.787-11.203,39.063-11.203c3.635,0,7.078,2.435,10.326,7.306c3.245,4.87,6.006,10.521,8.28,16.949 c2.271,6.43,3.41,10.554,3.41,12.372c0,6.624-1.689,14.451-5.065,23.476c-3.379,9.029-7.958,19.516-13.735,31.465 c-5.781,11.951-12.956,26.885-21.528,44.809c6.752-8.699,13.181-16.754,19.288-24.158c6.104-7.402,12.176-14.611,18.216-21.625 c6.039-7.014,12.176-14.091,18.411-21.236c8.441-9.741,17.923-19.059,28.445-27.958c10.52-8.895,20.358-16.17,29.516-21.82 c9.156-5.649,15.357-8.475,18.605-8.475c4.545,0,8.603,2.502,12.177,7.501c3.57,5.001,5.357,10.359,5.357,16.073 c0,3.769-2.469,10.977-7.403,21.625c-4.938,10.651-12.146,24.289-21.625,40.913c-9.483,16.627-22.016,38.058-37.602,64.292 c14.807-15.714,30.197-31.885,46.174-48.512c15.975-16.623,27.859-28.767,35.652-36.432 c7.793-7.662,14.286-13.507,19.482-17.534c7.142-5.455,14.319-11.33,21.528-17.632c7.208-6.298,12.889-11.266,17.047-14.904 c4.155-3.635,7.856-6.429,11.104-8.377c3.245-1.948,6.234-2.922,8.963-2.922c3.375,0,7.628,3.896,12.761,11.689 c5.129,7.793,7.695,12.794,7.695,15.001c0,2.728-1.528,5.976-4.578,9.741c-3.054,3.769-9.386,10.782-18.995,21.041 c-17.666,18.965-32.993,38.088-45.979,57.376c-12.99,19.287-22.828,36.889-29.517,52.797 c-6.69,15.912-10.033,28.478-10.033,37.698c0,5.717,1.071,9.873,3.215,12.469c2.143,2.6,5.485,3.896,10.033,3.896 c4.155,0,8.019-0.779,11.592-2.338c3.571-1.559,7.531-3.766,11.885-6.623c4.35-2.855,8.475-5.584,12.371-8.184 c5.455-3.244,10.813-6.721,16.073-10.423c5.26-3.701,9.352-6.624,12.273-8.767C966.569,958.983,968.742,957.458,970.174,956.548 z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "#2B363F"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    d: "M615.788,760.555v272.169V760.555z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.788,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.434,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.079,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.725,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.37,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.016,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.661,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.307,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.952,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.598,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.243,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.889,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.534,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.18,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.825,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.471,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.116,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.762,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.407,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.053,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.698,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.645,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.343,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.989,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.634,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655.28,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.925,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.571,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.216,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.862,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.507,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.153,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.798,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.444,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.089,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.735,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.38,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.026,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.671,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.317,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679.962,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.608,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.253,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.899,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.544,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.19,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689.835,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.481,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.126,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.772,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.417,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 698.063,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.708,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.354,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704.645,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.291,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.936,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.582,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.227,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.873,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 714.518,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 716.164,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.646,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.809,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.296,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.782,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.269,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.755,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725.242,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.729,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.215,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729.702,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731.188,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732.675,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 734.162,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.648,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.135,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.621,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740.108,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.595,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.081,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.568,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.054,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747.541,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.027,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.514,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 753.487,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.974,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.46,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 757.947,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.434,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760.92,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 762.407,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 763.894,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 765.38,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.867,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 768.353,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 769.84,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.326,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.813,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.299,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.786,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.272,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.759,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780.246,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.732,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.219,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.706,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786.192,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.679,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.166,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790.652,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.139,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.625,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.112,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.598,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.085,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 799.571,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 801.058,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.545,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.031,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.518,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 807.004,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.491,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809.978,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.464,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 812.951,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.438,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.924,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 817.411,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.897,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.384,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 821.87,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823.357,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.844,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.33,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 827.817,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.303,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830.79,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.276,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 833.763,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835.25,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 836.736,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.223,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.709,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.196,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.683,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.169,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.656,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.143,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 848.629,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.116,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.602,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.089,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.575,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.062,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857.548,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 859.035,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860.521,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.008,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.495,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.981,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866.468,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 867.955,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 869.441,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.928,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.415,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.901,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.388,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.874,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.361,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.847,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.334,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.82,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 884.307,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.793,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 887.28,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.767,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.253,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891.74,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 893.227,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.713,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.2,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 897.687,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.173,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.66,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902.146,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.633,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.119,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.606,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 908.093,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 909.579,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.066,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 912.552,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 914.039,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.525,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 917.012,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.499,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.985,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 921.472,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.958,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.486,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.445,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 1.487,
    height: 272.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 925.931,
    y: 760.555,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B363F",
    width: 69.375,
    height: 272.169
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M1058.623,964.925l-34.678,29.418c-16.497,14.418-27.538,21.626-33.121,21.626 c-5.064,0-10.393-5.812-15.975-17.437c-5.587-11.623-8.378-21.787-8.378-30.49c0-7.403,1.136-13.668,3.409-18.801 c2.271-5.129,6.201-11.787,11.787-19.969c7.921-11.039,15.519-20.391,22.795-28.055c7.271-7.662,13.701-13.604,19.287-17.827 c5.583-4.219,9.479-6.331,11.689-6.331c3.507,0,6.916,1.82,10.229,5.455c3.312,3.637,4.968,7.402,4.968,11.299 c0,2.469-1.787,6.43-5.357,11.885c-3.574,5.455-9.224,12.371-16.95,20.749c-7.729,8.377-18.478,18.411-32.243,30.101 l-3.702,10.715c-1.041,2.079-1.559,3.896-1.559,5.455c0,3.507,1.754,5.26,5.261,5.26c3.635,0,12.177-4.608,25.619-13.832 c13.443-9.221,28.021-21.625,43.738-37.211c6.104-6.104,11.169-11.495,15.196-16.171c4.024-4.676,7.662-9.06,10.91-13.15 c3.245-4.092,5.942-7.175,8.085-9.255c2.144-2.076,4.058-3.181,5.747-3.312c3.245-0.39,5.778,0.974,7.599,4.091 c1.817,3.117,2.728,7.729,2.728,13.833c0,3.507-1.559,7.891-4.676,13.15c-3.117,5.261-8.962,14.223-17.534,26.886 c-8.572,12.664-17.114,25.784-25.619,39.354c-8.509,13.574-17.179,28.868-26.009,45.882c0.389-0.391,4.383-4.287,11.981-11.689 c7.598-7.404,15.616-15.13,24.061-23.185c8.441-8.052,15.392-14.515,20.847-19.385c5.455-4.871,12.273-10.552,20.456-17.048 v13.054c-17.534,18.834-33.412,36.694-47.635,53.577c-14.222,16.883-25.199,30.393-32.925,40.523 c-7.729,10.131-12.244,16.039-13.541,17.729c-3.506,4.545-6.657,8.797-9.448,12.761c-2.795,3.96-5.133,7.014-7.014,9.157 c-1.885,2.143-3.409,3.215-4.579,3.215c-2.727,0-5.162-2.697-7.306-8.086c-2.143-5.391-3.214-10.164-3.214-14.319 c0-3.769,0.712-7.081,2.143-9.937C1005.047,1053.57,1026.021,1017.01,1058.623,964.925z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible",
    fill: "#2B363F"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    d: "M966.472,877.06v229.893V877.06z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.472,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 967.134,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 967.796,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 968.458,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.121,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.783,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 970.445,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 971.107,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 971.77,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.432,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.094,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.756,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 974.419,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.081,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.743,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 976.405,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.068,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.73,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.392,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 979.055,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 979.717,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980.379,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.041,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.704,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 982.366,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 983.028,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 983.69,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 984.353,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 985.015,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 985.677,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 986.339,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.001,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 987.664,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 988.326,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 988.988,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 989.65,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.313,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.975,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.637,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992.299,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992.962,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 993.624,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 994.286,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 994.949,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 995.611,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.273,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.936,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997.598,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 998.26,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 998.922,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 999.584,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000.247,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000.909,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1001.571,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.233,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.896,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.558,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1004.22,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1004.882,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1005.544,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.663,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.207,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.869,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.662,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1007.531,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.129,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.728,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.326,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1009.924,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.523,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.121,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.719,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012.318,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1012.916,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.514,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.112,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.711,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.309,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.907,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.506,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.104,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.702,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.301,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1018.899,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1019.497,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020.096,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020.694,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.292,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.891,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.489,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.087,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.686,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.284,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.882,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025.48,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.079,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.677,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.275,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.874,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1028.472,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.07,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.668,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030.267,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030.865,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031.463,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.062,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.66,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.258,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.856,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1034.455,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035.053,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035.651,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.25,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.848,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1037.446,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.044,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.643,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1039.241,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1039.839,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.438,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1041.036,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1041.634,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.232,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.831,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1043.429,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.027,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.626,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.224,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.822,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1046.421,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047.019,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047.617,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.215,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.814,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.412,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.01,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.609,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.207,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.805,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1052.404,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1053.002,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1053.6,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.199,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.797,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1055.395,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1055.994,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056.592,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1057.19,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1057.789,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.387,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.985,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1059.583,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060.182,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060.78,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1061.378,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1061.977,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.575,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.173,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.771,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064.37,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064.968,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.566,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.165,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.763,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067.361,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067.959,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1068.558,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1069.156,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1069.754,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.353,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.951,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1071.549,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1072.147,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1072.746,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1073.344,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1073.942,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.541,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.139,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.737,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.335,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1076.934,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.532,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.13,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.729,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079.327,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079.925,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.524,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.122,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.72,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1082.319,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1082.917,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1083.515,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.113,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.712,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085.31,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085.908,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086.507,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.105,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.703,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.302,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.9,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1089.498,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.599,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.097,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.695,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 0.598,
    height: 229.893
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.293,
    y: 877.06,
    clipPath: "url(#SVGID_4_)",
    fill: "#2B363F",
    width: 27.921,
    height: 229.893
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.0264,
    y1: -385.6968,
    x2: 866.5986,
    y2: -385.6968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA2424"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 314.026,
    y: -442.686,
    fill: "url(#SVGID_5_)",
    width: 552.572,
    height: 113.978
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 721.2192 1434.9409)",
    fontFamily: "'Rockwell'",
    fontSize: 90
  }, "onde as ideias se completam")));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.61988a1b.svg";
export { ForwardRef as ReactComponent };